// Third-party
import React from 'react';
import { SeriesScatterDataOptions } from 'highcharts';
import classNames from 'classnames';

// Components
import GenericLegend from '@/views/components/charts/GenericLegend';
import { HoldingIcon } from '@/views/components/common';
import { ScatterPlotDatum } from '@/views/components/charts/scatter-plot/ScatterPlot';

// Utils
import { formatMessage, FormattedMessage, formatNumber, formatPercentage } from '@/utils/i18n';
import { currencyToText } from '@/utils/currency';
import ComparisonItem from '@/types/comparison-item';

type Props = {
  items: ComparisonItem[];
  data: ScatterPlotDatum[];
  showBaseCurrencies?: boolean;
};

const RiskRewardPlotLegend = ({ items, data, showBaseCurrencies }: Props) => {
  const legendItems = items.map(item => {
    const datum = data.find(d => d.key.indexOf(item._id) > -1);

    return {
      id: item._id,
      color: item.color,
      getValue: () => {
        let point: SeriesScatterDataOptions = {};

        if (datum && datum.data && datum.data[0]) {
          point = datum.data[0] as SeriesScatterDataOptions;
        }

        return (
          <>
            <div className="item-label">
              <HoldingIcon type={item.type} color={item.color} />
            </div>

            <div className="d-flex justify-content-between">
              <span className="label">
                <FormattedMessage id="RiskRewardPlot.Tooltip.LabelX" />
                <span>&nbsp;</span>
              </span>

              <span className={classNames({ 'no-value': point.x == null })}>
                {point.x != null ? formatNumber(point.x, 2) : formatMessage('Common.NotApplicable')}
              </span>
            </div>

            <div className="d-flex justify-content-between legend-return">
              <span className="label">
                <FormattedMessage id="RiskRewardPlot.Tooltip.LabelY" />
                <span>&nbsp;</span>
              </span>

              <span className={classNames({ 'no-value': point.y == null })}>
                {point.y != null ? `${formatPercentage(point.y, 2)}` : formatMessage('Common.NotApplicable')}
              </span>

              {point.y && point.currency && !!showBaseCurrencies && (
                <div className="currency-label">
                  <span>{currencyToText(point.currency)}</span>
                </div>
              )}
            </div>
          </>
        );
      },
    };
  });

  return <GenericLegend className="risk-reward-plot-legend" items={legendItems} />;
};

export default RiskRewardPlotLegend;
